const releases = [
    {
        name: "New Digital Devil Saga",
        items: [
            {
                index: "NDDS1",
                name: "NDDS1: Goddess Bound",
                status: "Chapter 1 Done",
                author: "Aya Nishitani",
                updated: "2022-07-06",
                pdflink: "1T5L5PlW0mWOb9CRklCBIN0rvyH5l8lF7",
                epublink: "1UOg_U5wglM27kJx8kZF_hauWA5H6-Zi5",
                megalink: "9oszwKZK#o3TTexK4macbzXnOpMLqTA"
            },
        ]
    },
    {
        name: "Adachi and Shimamura Shorts",
        items: [
            {
                index: "afterschool",
                name: "Shortly After",
                status: "Completed",
                author: "Hitoma Iruma",
                updated: "2025-28-5",
                short: "short",
            },
            {
                index: "Mothers",
                name: "What If They Had Children?",
                status: "Completed",
                author: "Hitoma Iruma",
                updated: "2025-14-5",
                short: "short",
            },
            {
                index: "NoesOfElephant",
                name: "The Noes of Elephant",
                status: "Completed",
                author: "Hitoma Iruma",
                updated: "2022-6-11",
                short: "short",
            },
            {
                index: "ChristmasLastYear",
                name: "We Did Christmas Last Year,\n So How About Winter Break This Time",
                status: "Completed",
                author: "Hitoma Iruma",
                updated: "2022-6-8",
                short: "short",
            },
            {
                index: "QuestionsAndAnswers1",
                name: "Questions and Answers",
                status: "Completed",
                author: "Hitoma Iruma",
                updated: "2020-5-16",
                short: "short",
            }
        ]
    },
    {
        name: "Adachi and Shimamura Extras",
        items: [
            {
                index: "adachiBD4",
                name: "Anime Special Novel 4",
                status: "Completed",
                author: "Hitoma Iruma",
                updated: "2021-04-23",
                pdflink: "15ZoKMZxfEUPe3QQt_qXV-sfHrJQCYQuR",
                epublink: "1MmQSyBorwhjSzFpUWhU0fiLoYvvBKdja",
                megalink: "9oszwKZK#o3TTexK4macbzXnOpMLqTA"
            },
            {
                index: "adachiBD3",
                name: "Anime Special Novel 3",
                status: "Completed",
                author: "Hitoma Iruma",
                updated: "2021-06-24",
                pdflink: "1DldNX8C66sVqR5HshLIxSyliKn3IZGbc",
                epublink: "1XMPtaDd41ipwk0mA6nDJJApTZdtEVuHb",
                megalink: "gh1SlKQK#P14aT4q3q7sbWT4lZoH4wg"
            },
            {
                index: "adachiBD2",
                name: "Anime Special Novel 2",
                status: "Completed",
                author: "Hitoma Iruma",
                updated: "2021-02-12",
                pdflink: "1BDiWoLz5bFGCOA31OGghjQgwQZ86vv3Y",
                epublink: "1hsjBZAWVehT_0CbnSaa4lQTfSuQuuFGq",
                megalink: "k8cGBBZC#81es1WxukVzH5AwHJ_ClZA"
            },
            {
                index: "adachiBD1",
                name: "Anime Special Novel 1",
                status: "Completed",
                author: "Hitoma Iruma",
                updated: "2020-12-30",
                pdflink: "1QTFnhSwR7CPZZ7HOBhRI5bRBIg2dK8rh",
                epublink: "1LT_VBRHALDnfaoaUN0PrEclIqnbTrddC",
                megalink: "0tlSVKKa#PMn66iu4uGx566WcodSaJg"
            },
        ]
    },
    {
        name: "Adachi and Shimamura",
        items: [
            {
                index: "adachi13",
                name: "Adachi and Shimamura 13",
                status: "Chapter 3 Done",
                author: "Hitoma Iruma",
                updated: "2026-06-10",
                pdflink: "1UWcfFvz2HsZiKbyYoRSXc0Zt_sFjqH-M",
                epublink: "13tg463dZdB9DTmgXrs81gifS7t4dzmUW",
                megalink: "98FQjIAA#9MYcFRq7TMXv6d-Ptk2Pzg"
            },
            {
                index: "adachiSS2",
                name: "Adachi and Shimamura SS2",
                status: "Completed",
                author: "Hitoma Iruma",
                updated: "2025-10-21",
                pdflink: "18OZMOfM-xTltRH7j-h0Y_ghPo7xX9ihU",
                epublink: "1gnvRBopZDxR89j7w1IOFvFmuWxBrmhS5",
                megalink: "c1EyHI5Q#shLhAat2k8F6eCShsg_4NQ"
            },
            {
                index: "adachi12",
                name: "Adachi and Shimamura 12",
                status: "Completed",
                author: "Hitoma Iruma",
                updated: "2025-06-22",
                pdflink: "1DTBImJ3889lDL06dkbCuXvGS7ITqjB07",
                epublink: "1PmJt7585wwJczj9hjCCvAZWJmRRteOC4",
                megalink: "AtcR1SyY#pJ97W_XXeg5Umm1-AsYuww"
            },
            {
                index: "adachiSS",
                name: "Adachi and Shimamura SS",
                status: "Completed",
                author: "Hitoma Iruma",
                updated: "2024-04-13",
                pdflink: "11LEwWm8xdcDLI40AGTtxbx1KBTQet2yU",
                epublink: "1wst-9fALmMZKQ0Lzd4RzxufPuHfGETdN",
                megalink: "xptXHaDI#hoX9O5VES0Ekc5GsX0qmhQ"
            },
            {
                index: "adachi99",
                name: "Adachi and Shimamura 99",
                status: "Completed",
                author: "Hitoma Iruma",
                updated: "2023-11-20",
                pdflink: "1z7F1tLwMRkVo_d7-VC0FeZTrCDs2wvGI",
                epublink: "15S9bcii-Vq3F5QsMOun0d2_CS3Rp7eHb",
                megalink: "Ep0l3ZJD#CvmLK2G-azuKFEtDX2tTQw"
            },
            {
                index: "adachi11",
                name: "Adachi and Shimamura 11",
                status: "Completed",
                author: "Hitoma Iruma",
                updated: "2023-04-12",
                pdflink: "1599hZ_ITGsX0t260bVKcylDA3LH4lNGm",
                epublink: "1a56J9Cio91TCAcLSQbmP2F0eIBYVtK66",
                megalink: "xo1GnLJR#omCG94LNPwt5ZGtnm235Kw"
            },
            {
                index: "adachi10",
                name: "Adachi and Shimamura 10",
                status: "Completed",
                author: "Hitoma Iruma",
                updated: "2022-05-08",
                pdflink: "1Fyn5DrQs_fUsUsDH55cwtUlOVheMTu0Z",
                epublink: "1dt54eg3sGqRDus7eF14ubd6pvEalHs3v",
                megalink: "BxNgFJhR#W175VsnBYk5oCbG_k7jpcA"
            },
            {
                index: "adachi9",
                name: "Adachi and Shimamura 9",
                status: "Completed",
                author: "Hitoma Iruma",
                updated: "2020-12-15",
                pdflink: "1EzGgpsc2mmFe2DsZE8SBnZkcBQ9ey-eh",
                epublink: "1Sm6p57CUlyOCHAijask75WwBiiT_LORE",
                megalink: "E9tFFSJB#adUFSW3xqodHmpsOIDp-cA"
            },
            {
                index: "adachi8",
                name: "Adachi and Shimamura 8",
                status: "Completed",
                author: "Hitoma Iruma",
                updated: "2020-09-26",
                pdflink: "1DxYdnjgkSCcETNRxBoPXHzDelfQVsk6Z",
                epublink: "1UHedcXj7YKlcagt4PtJFkgau5Yv6-2KI",
                megalink: "Z48GxSRJ#ml4lN3GFmrv1ALsnA6_c4w"
            },
            {
                index: "adachi7",
                name: "Adachi and Shimamura 7",
                status: "Completed",
                author: "Hitoma Iruma",
                updated: "2020-07-14",
                pdflink: "1a58AHQ40rNwvGUdW2rViFu4Yo3rHIQSE",
                epublink: "1IhZCWCi7Pr9bmNS1KEUemPmbwVPkiT5u",
                megalink: "kt8Tibxa#xvAmCLYaWcJKiwV512MMQg"
            },
            {
                index: "adachi6",
                name: "Adachi and Shimamura 6",
                status: "Completed",
                author: "Hitoma Iruma",
                updated: "2020-05-14",
                pdflink: "1YPppyZlgizyVucFDbkyXkGnTQ6LB_yp4",
                epublink: "1J7Tas5YpenEvwngflbFlcIi0MvE5GP4L",
                megalink: "JhlAkKYI#kmXTw3XoGOvR3FH0rIdOOA"
            },
            {
                index: "adachi5",
                name: "Adachi and Shimamura 5",
                status: "Completed",
                author: "Hitoma Iruma",
                updated: "2020-02-27",
                pdflink: "1c4s-GRXt4AsBhzxek_YXWJLb6wn06O2N",
                epublink: "1WL2L-8_eWRiljP2sRHI92K8C6T6E2Qjt",
                megalink: "4tMA1AoS#bFmjT8mNyrtc7D5oG6Ka2g"
            },
            {
                index: "adachi4",
                name: "Adachi and Shimamura 4",
                status: "Completed",
                author: "Hitoma Iruma",
                updated: "2019-12-22",
                pdflink: "1z_eNCuuaKP7CMFif9U-HAPgU184ptZ2c",
                epublink: "1TCoUf0ABDw0n_K51Dg3NOvbIH3WYgpKi",
                megalink: "do93VYpI#VbYSPLps1b9BH2_JZLgy3A"
            },
            {
                index: "adachi3",
                name: "Adachi and Shimamura 3",
                status: "Completed",
                author: "Hitoma Iruma",
                updated: "2019-10-18",
                pdflink: "1BLJeHqW8RDe-nwXRfPk4kDcSSD182EIO",
                epublink: "1WcWuDYlQ5__6PZ4I3Es-Bzc87RVaoJUu",
                megalink: "Y4U3RKDY#Degyv3ptBiPOtBlf4pWzbQ"
            },
            {
                index: "adachi2",
                name: "Adachi and Shimamura 2",
                status: "Completed",
                author: "Hitoma Iruma",
                updated: "2019-08-09",
                pdflink: "1puUd5YQ1aHfhfGxvApaTc0KTLGCd1-ZM",
                epublink: "1B-cWB8z_7tIkQlgTHOItmFt_daTekDyW",
                megalink: "l98TRYaQ#8e-JL8PJx4cDwN1SCeJnuw"
            },
            {
                index: "adachi1",
                name: "Adachi and Shimamura 1",
                status: "Completed",
                author: "Hitoma Iruma",
                updated: "2019-05-16",
                pdflink: "1y6iBdgnIrJ93t6Iyt1Zpmklwhbh2E-NC",
                epublink: "1asmOF64aYjY-rkjkuZwOyhBK6Eeoe-LW",
                megalink: "JoVBRIgJ#80VybFiaAC0ckl0bsCer9g"
            }
        ]
    },
    {
        name: "One Shots",
        items: [
            {
                index: "vamp",
                name: "Scarlet Lily Bond",
                status: "Chapter 1 done",
                author: "Ningen Mukotsu",
                updated: "2021-01-10",
                pdflink: "1hpyb_mIQHdIDfBBW4TAV6M5IWpFyf43I",
                epublink: "1b5R7LjJZmD7QevPqzZ9ludrzfBtwdLYZ",
                megalink: "R4F0EL5b#zEJoatbi-Z13Be1WhYfgxA"
            },
            {
                index: "elf",
                name: "Lesbian Elf and a Cursed Princess",
                status: "Completed",
                author: "Araoshi Yuu",
                updated: "2019-03-02",
                pdflink: "10Te42BUiTnUcOGeglYRX86LyZ2c7syXX",
                epublink: "1kSMoTe7wWANuDPlbxIAkRDxfnGZkQvOj",
                megalink: "sosXjIwb#rUzJSN2kjomXXUSLebmZVw"
            }
        ]
    }
]

export function getReleases() {
    return releases
}